<template>
  <div class="upload-signed-contract-modal">
    <HMModalHeader
      :title="$t('CONTRACTS.TITLES.UPLOAD_SIGNED_CONTRACT')"
      @close="$emit('close')"
    />
    <HMFileUpload
      class="w-100"
      v-model="file"
      accept="application/pdf"
      @input="fileUploaded"
    />
  </div>
</template>

<script>
export default {
  name: 'UploadSignedContractModal',
  computed: {},
  data() {
    return {
      file: null,
    };
  },
  methods: {
    fileUploaded() {
      this.$parent.$emit('onFileUploaded', this.file);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped></style>
